import type { ChatDraft } from "@/types/draft-strorage";

const DB_NAME = "vidmuse_drafts";
const STORE_NAME = "drafts";
const DRAFT_KEY_PREFIX = "chat_draft";

/**
 * 生成草稿键
 * @param threadId - 线程 ID，如果为 undefined 则生成新建草稿的键
 * @returns 草稿键字符串
 */
export function getDraftKey(threadId?: string): string {
  return threadId
    ? `${DRAFT_KEY_PREFIX}:${threadId}`
    : `${DRAFT_KEY_PREFIX}:new`;
}

function openDB(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    if (typeof indexedDB === "undefined") {
      reject(new Error("indexedDB is not available"));
      return;
    }
    const request = indexedDB.open(DB_NAME, 1);
    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export async function setDraft(key: string, value: ChatDraft): Promise<void> {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readwrite");
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
    tx.objectStore(STORE_NAME).put(value, key);
  });
}

export async function getDraft(key: string): Promise<ChatDraft | undefined> {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readonly");
    const req = tx.objectStore(STORE_NAME).get(key);
    req.onsuccess = () => resolve(req.result as ChatDraft | undefined);
    req.onerror = () => reject(req.error);
  });
}

export async function deleteDraft(key: string): Promise<void> {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readwrite");
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
    tx.objectStore(STORE_NAME).delete(key);
  });
}
